import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx={12}
      cy={12}
      r={11}
      stroke="currentColor"
      strokeWidth={2}
      strokeDasharray={48}
    >
      <animate
        attributeName="stroke-dashoffset"
        from={48}
        to={-48}
        dur="3.5s"
        repeatCount="indefinite"
      />
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 12 12"
        to="360 12 12"
        dur="2s"
        repeatCount="indefinite"
      />
    </circle>
    <circle
      cx={12}
      cy={12}
      r={6}
      stroke="currentColor"
      strokeWidth={2}
      strokeDasharray={48}
    >
      <animate
        attributeName="stroke-dashoffset"
        from={48}
        to={-48}
        dur="3.5s"
        repeatCount="indefinite"
      />
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 12 12"
        to="360 12 12"
        dur="2s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);
